import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { TransactionType } from "../../transactions/_types/transaction-type";

export class TransactionSerie extends Resource {
    public override type = 'transactionSeries';

    @prop()
    public transactionTypeId!: string;

    @prop()
    public transactionType!: TransactionType;

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public prefix!: string;

    @prop()
    @required()
    public returnPrefix!: string;

    @prop()
    public numberLength!: number;

    @prop()
    public firstNumber!: number;

    @prop()
    public active: boolean = true;

    @prop()
    public isDefault: boolean = false;
}